import React,{useState} from "react";
import axios from "axios";
import "../../Styles/Components/Identity/Login.css";
import Dialog_alert from '../PublicForms/Dialog_alert.js';
import {useNavigate } from "react-router-dom";
import Config from "../PublicForms/Config.js";
import header from "../../Images/headerLogo.png";

const Login = ()=>
{

    const[userName, setUserName] = useState("");
    const[password, setPassword] = useState("");
    const[message, setMessage] = useState([]);
    const[messTitle, setMessTitle] = useState("");
    const[showDialog, setShowDialog] = useState(false);

    const Navigate = useNavigate();


    const closeOpenDialog = (open) =>
    {
        setShowDialog(false);
          
    }


    function Login()
    {
       
        axios.get(`${Config.apiBaseUrl}/api/Users/UserName/UserPassword?UserName=${userName}&UserPassword=${password}`)
        .then(response => 
        {
            if(response.status === 200)
            {
                localStorage.setItem("token", response.data);             
                Navigate("/dashboard/analysis/داشبورد/analysis");
               

            }else
            {
                setMessage([])
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                      ...prevMessages, // shallow copy into new array reference
                      "لطفا مجددا تلاش کنید",      // append new element
                    ];
                });
                setShowDialog(true);
            }

        }).catch((err) =>{

                if(err.response !== null && err.response !== undefined)
                {
                    setMessage([]);
                    if((err.response.status) === 500)
                    {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                  ...prevMessages, // shallow copy into new array reference
                                  (err.response.data.detail),      // append new element
                                ];
                            });
                            setShowDialog(true);
            
                    }else
                    {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                  ...prevMessages, // shallow copy into new array reference
                                  "لطفا مجددا تلاش کنید",      // append new element
                                ];
                            });
                            setShowDialog(true);
            
                    }
    
                }else if(err.message == "Network Error")
                {
                    setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                  ...prevMessages, // shallow copy into new array reference
                                  "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                                ];
                            });
                            setShowDialog(true);
                }else
                {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                        ...prevMessages, // shallow copy into new array reference
                        ("لطفا مجددا تلاش کنید"),      // append new element
                    ];
                });                
                
                setShowDialog(true);
                }
            
            
       })
        
    }


    return(

        <div className="login">

            <div className="top-box"></div>

            <div className="login-box shadow-top">

                    <div className="login-img">
                    
                    <img src ={header} />

                    </div>

                    <form>
                        <div class="form-group">
                            <label for="email">نام کاربری</label>
                            <input type="text" class="form-control" id="email" onChange={(e)=> setUserName(e.target.value)}/>
                        </div>
                        <div class="form-group">
                            <label for="pwd">رمز عبور</label>
                            <input type="password" class="form-control" id="pwd" onChange={(e)=>setPassword(e.target.value)}/>

                        </div>
                        {/* <div class="checkbox">
                                    
                        
                        <label><input type="checkbox"/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;من را بخاطر بسپار</label> 
                            
                        </div> */}

                            {/* <button type="button" className="btn btn-primary col-12 col-md-6" onClick={()=>goToRegister()}>ثبت نام</button> */}
                            <button type="button" className="btn col-12" onClick={()=>{
                                setMessage([]);
                                Login();}} >ورود</button>

                    </form>

                    {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}


            </div>           

        </div>
    )

}

export default Login;
